import React from "react";

export const rook_outline = (stroke) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24.003"
        height="23.977"
        viewBox="0 0 24.003 23.977"
    >
        <g id="g2532" transform="translate(-10.282 -6.102)">
            <path
                id="path3097"
                d="M11.2,29.112c0-.185.407-2.537.493-2.848.225-.817.641-1.292,1.756-1.969.641-.392.661-.411.742-.659a22.654,22.654,0,0,0,.605-3.543c.1-.9.586-6.4.566-6.41-.177-.117-1.475-1.048-1.771-1.269a3.679,3.679,0,0,1-.6-.56c-.352-.467-.375-.623-.4-2.8L12.563,7.1h1.922c1.183,0,2.033.021,2.205.054.4.078.449.168.478.879.029.744.092.966.325,1.151s.506.222,1.139.192c.51-.024.732-.113.894-.358.092-.133.106-.277.122-1.055l.018-.9,2.461-.037c2.785-.042,2.818-.039,2.911.264a2.1,2.1,0,0,1,.059.481,4.1,4.1,0,0,0,.189,1.385c.123.169.35.234.824.234a1.363,1.363,0,0,0,.641-.112c.366-.169.442-.346.487-1.184.041-.783.081-.859.478-.942.118-.025,1.086-.045,2.15-.046H31.8V8.925c0,1.026-.026,1.965-.058,2.144-.125.7-.355.95-1.852,2.016-.784.554-.837.606-.837.763,0,.32.5,5.8.607,6.69a16.842,16.842,0,0,0,.593,3.21,2.657,2.657,0,0,0,.676.527,4.39,4.39,0,0,1,1.323,1.071c.359.5.472.906.725,2.6.078.519.153,1.005.167,1.081l.027.137H22.186c-7.042,0-10.984-.018-10.984-.048Z"
                stroke={stroke}
                strokeWidth="1"
            />
        </g>
    </svg>
);
